import { httpPost } from "../../../../../../../Utils/apis/apis";
import { getSubDomain } from "../../../../../Pages/Common/User Management/HelperFunctions";
export const fileListWithDisplayName = (fileList) => {
  let listwithdisplayname = [];
  if (fileList) {
    fileList.map((file) => {
      let fileArr = file.file.split("/");
      file = { ...file, fileDisplayName: fileArr.slice(-1)[0] };
      listwithdisplayname.push(file);
    });
  }
  return listwithdisplayname;
};
export const documentRowsPerPageOptions = [5, 10, 25, 50, 100, 150, 200];
const DEFAULT_DOCUMENT_ROWS_PER_PAGE = 5;

export const isDocumentPaginated = (paginate) =>
  paginate === true || paginate === "true" || Number(paginate) > 0;

export const getDocumentRowsPerPage = (paginate) => {
  const size = Number(paginate);
  return documentRowsPerPageOptions.includes(size)
    ? size
    : DEFAULT_DOCUMENT_ROWS_PER_PAGE;
};

export const sortFiles = (list, key) => {
  return list.sort((a, b) => a[key].localeCompare(b[key]));
};

export const normalizeFilePrefix = (prefix) =>
  prefix ? `${prefix}`.replace(/^\/+|\/+$/g, "") : "";

export const getDocumentListPath = (filePrefix, path) =>
  normalizeFilePrefix(filePrefix) || path;
export const downloadDocument = async (
  e,
  type = "generic",
  additionDownloadHelper
) => {
  let documentName = e.file;
  let url = `${process.env.DOCUMENT_HELPER}`;
  const subdomain = getSubDomain();
  if (documentName.includes("//")) {
    documentName = documentName.replace(/\/\//g, "/");
  }
  let header = {
    filename: documentName,
    type: type,
    "file-operation": "download",
    "process-file": "yes",
    "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
    subdomain: subdomain,
  };

  if (additionDownloadHelper) {
    let { extraHeaders = {}, apiUrl } = additionDownloadHelper;
    header = { ...header, ...extraHeaders };
    url = apiUrl
      ? apiUrl.startsWith("http")
        ? apiUrl
        : `${process.env.API_URL}${apiUrl}`
      : url;
  }
  await httpPost(
    url,
    {
      method: "GET",
    },
    { responseType: "blob", headers: header }
  ).then((response) => {
    const url1 = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url1;
    link.setAttribute("download", e.fileDisplayName);
    document.body.appendChild(link);
    link.click();
  });
};
export const onDeleteDocument = async (e, type = "generic") => {
  const documentName = e.file;
  const url = `${process.env.DOCUMENT_HELPER}`;
  let subdomain = new URL(window.location.href).hostname.split(".")[0];
  let header = {
    filename: documentName,
    type: type,
    "file-operation": "delete",
    "process-file": "no",
    "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
    subdomain: subdomain,
  };
  await httpPost(
    url,
    {
      method: "GET",
    },
    { responseType: "blob", headers: header }
  );
};
